import { useEffect } from "react";

import {
  applyThemeClass,
  prefersDarkScheme,
  resolveTheme,
  useThemeStore,
} from "@/stores/theme-store";

/**
 * Applies the persisted theme preference on mount and, when the preference is
 * `system`, follows live OS changes. Also keeps `<meta name="color-scheme">`-style
 * behaviour by toggling the `.dark` class + `data-theme` attribute.
 */
export function useThemeInitialization(): void {
  const preference = useThemeStore((state) => state.preference);

  useEffect(() => {
    const apply = (): void => {
      applyThemeClass(resolveTheme(preference, prefersDarkScheme()), document.documentElement);
    };
    apply();
    if (preference !== "system" || typeof window.matchMedia !== "function") return;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    media.addEventListener("change", apply);
    return () => {
      media.removeEventListener("change", apply);
    };
  }, [preference]);
}
